const reducer = (state = false, action) => {
  switch (action.type) {
    case 'is_empty':
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
